import {
  OutsideTemperatures,
  OutsideTemperaturesValues,
} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import {Logger} from '@feature-hub/core';

const DEFAULT_OUTSIDE_TEMPERATURE = 20; // °C

export const getDefaultOutsideTemperature = (
  appDataContentValue: string | undefined,
  acsValue: number | undefined,
  logger?: Logger
) => {
  const validateAndReturn = (value: any): OutsideTemperatures | undefined => {
    // CMS limitation - we must receive string values and parse to number
    const parsedValue =
      typeof value === 'string' ? Number(value.trim()) : value;

    if (
      Number.isInteger(parsedValue) &&
      OutsideTemperaturesValues.includes(parsedValue)
    ) {
      return parsedValue;
    }

    logger?.warn(
      `Invalid value for default temperature: ${value}. It must be one of the following values: ${OutsideTemperaturesValues.join(
        ', '
      )}. Using the default value: ${DEFAULT_OUTSIDE_TEMPERATURE}.`
    );
    return undefined;
  };

  const validAppDataValue =
    appDataContentValue !== undefined && appDataContentValue.trim() !== ''
      ? validateAndReturn(appDataContentValue)
      : undefined;
  if (validAppDataValue !== undefined) return validAppDataValue;

  const validAcsValue =
    acsValue !== undefined ? validateAndReturn(acsValue) : undefined;
  if (validAcsValue !== undefined) return validAcsValue;

  return DEFAULT_OUTSIDE_TEMPERATURE;
};
